{
  "title": "Frameriver Reels",
  "titleReels": "Reels",
  "brandPrefix": "Frame",
  "brandAccent": "river",
  "search": "Search presets",
  "optional": "optional",
  "required": "required",
  "generate": "Generate",
  "generating": "Generating…",
  "ready": "Ready",
  "download": "Download",
  "share": "Share",
  "linkCopied": "Link copied",
  "again": "Regenerate",
  "repeat": "Remake",
  "repeatUnavailable": "This preset is no longer available",
  "publicReel": {
    "unavailableTitle": "Reel unavailable",
    "unavailable": "This reel is unavailable",
    "openStudio": "Open studio",
    "mute": "Mute",
    "unmute": "Unmute"
  },
  "another": "Choose another preset",
  "pickAnotherPreset": "Pick another preset",
  "by": "by",
  "cancel": "Cancel",
  "camera": "Take photo",
  "cameraCapture": "Camera",
  "cameraShutter": "Capture",
  "cameraDenied": "Camera access denied — use upload instead",
  "cameraStarting": "Starting camera…",
  "upload": "Upload",
  "recent": "Recent",
  "trend": "Trending",
  "new": "New",
  "added": "Added",
  "examples": "What works well",
  "topUp": "Top up",
  "signIn": "Sign in",
  "costUnavailable": "Price unavailable",
  "notEnough": "Not enough balance — top up to generate",
  "askOwnerTopUp": "Ask your company owner to top up the balance",
  "onlineOnlySolo": "Online payment is only available for private accounts. Top up via studio billing.",
  "loginToContinue": "Sign in to add your photo and generate",
  "setupToContinue": "Create a studio or private account to generate and top up",
  "payment": {
    "title": "Top up",
    "subtitle": "Choose an amount",
    "topUpHint": "Pay by card or SBP via YooKassa. You will return here after payment.",
    "topUpHintDesktop": "Card or SBP checkout opens in your browser. This window waits until the balance is credited.",
    "generateHint": "Pay the shortfall — generation starts automatically after payment.",
    "generateHintDesktop": "Checkout opens in your browser. This window waits until the balance is credited, then starts generation.",
    "shortageTitle": "{{amount}} short",
    "payShortage": "Pay {{amount}} and generate",
    "payFull": "Pay full generation cost · {{amount}}",
    "payMinimum": "Top up {{amount}}",
    "payAmount": "Pay {{amount}}",
    "amountLabel": "Amount, ₽",
    "minHint": "Minimum {{amount}}",
    "invalidAmount": "Enter a valid amount",
    "returnHint": "You will return to this screen after payment",
    "returnHintDesktop": "After you pay, this window shows that the balance was topped up.",
    "closeWhilePendingTitle": "Close the wait?",
    "closeWhilePending": "Payment is not confirmed yet. You can close this window — we will tell you when the balance is credited.",
    "closeWhilePendingConfirm": "Close",
    "waitingTitle": "Confirming payment",
    "waitingSubtitle": "This may take a few seconds",
    "waitingSubtitleDesktop": "Checkout is open in your browser",
    "waitingBody": "Waiting for the payment provider…",
    "waitingBodyDesktop": "This window waits until the payment is credited. You can close the browser after paying.",
    "startingGenerationTitle": "Starting generation",
    "startingGenerationSubtitle": "Payment received — preparing your video",
    "startingGenerationBody": "Starting generation…",
    "stillConfirmingTitle": "Still confirming payment",
    "stillConfirmingSubtitle": "You can close this — status will refresh on your next visit",
    "stillConfirmingBody": "Payment is still processing. Come back later — we will keep checking.",
    "stillConfirmingToast": "Still confirming payment — you can close this and return later",
    "generationFailed": "Payment succeeded, but generation did not start. Tap Generate — your balance is already topped up.",
    "unavailable": "Payments are temporarily unavailable. Try again later or contact support.",
    "successTopUp": "Balance topped up",
    "successGenerate": "Payment received — starting generation",
    "canceled": "Payment canceled",
    "card": "Bank card",
    "sbp": "SBP",
    "soon": "Payment will be available soon"
  },
  "loginDialog": {
    "heading": "frameriver",
    "subtitle": "Sign in to generate a video"
  },
  "signupDialog": {
    "subtitle": "Sign up to generate a video"
  },
  "emptyCatalog": "No published presets yet",
  "emptyCatalogHint": "Authors publish presets from Stories projects.",
  "emptyMine": "No reels yet",
  "emptyMineHint": "Generate a video from the catalog — it will show up here.",
  "categories": {
    "all": "All",
    "mine": "Mine",
    "mineCount": "Mine ({{count}})",
    "dance": "Dance",
    "travel": "Travel",
    "fashion": "Fashion",
    "food": "Food",
    "fitness": "Fitness",
    "other": "Other"
  },
  "reelStatus": {
    "queued": "Queued",
    "processing": "Generating",
    "completed": "Ready",
    "failed": "Failed",
    "cancelled": "Cancelled"
  },
  "yours": {
    "photo": "Your photos",
    "loc": "Your locations",
    "prop": "Your props"
  },
  "photo": {
    "label": "Your photo",
    "hint": "Face clearly visible, good light",
    "short": "required",
    "pick": "Add your photo"
  },
  "loc": {
    "label": "Location",
    "hint": "Place photo. Skip to keep the preset scene",
    "short": "optional",
    "pick": "Add a location"
  },
  "prop": {
    "label": "Prop",
    "hint": "Object that should be in frame",
    "short": "optional",
    "pick": "Add a prop"
  },
  "examplesPhoto": {
    "0": "Face in frame",
    "1": "Even light",
    "2": "Neutral background"
  },
  "examplesLoc": {
    "0": "Wide shot of place",
    "1": "Clear landmark",
    "2": "Daylight preferred"
  },
  "examplesProp": {
    "0": "Object alone",
    "1": "Plain background",
    "2": "Sharp details"
  },
  "favorite": "Favorite",
  "unfavorite": "Remove favorite",
  "costUnknown": "—",
  "setup": {
    "chooseType": "Choose account type",
    "title": "Production studio",
    "subtitle": "You need a workspace to save photos and generate video.",
    "nameLabel": "Studio name",
    "namePlaceholder": "My studio",
    "emailLabel": "Email",
    "acceptOffer": "I accept the offer agreement",
    "offerRequired": "Accept the offer to continue",
    "continue": "Continue",
    "offerLink": "View offer",
    "or": "or",
    "soloTitle": "Private account",
    "soloSubtitle": "Create a private account — no studio name. You can generate reels and top up balance.",
    "soloContinue": "Continue as private"
  }
}
